<template>
  <div id="app">
   <first-Component class="animated fadeIn" ></first-Component>
    <div id="scroller-wrapper" data-scrollbar >
      <div class="donghua animated fadeOutDown" :style="noShow">

      </div>
    <router-view/>
    </div>
  </div>
</template>

<script>
  import  {WOW} from 'wowjs'
  import Scrollbar from 'smooth-scrollbar';
  import firstComponent from './components/first'
export default {
  name: 'App',
  data(){
    return{
      noShow:{},
    }
  },
  watch:{
    '$route':'init'
  },
  components:{firstComponent},
  mounted() {
    if(this.$i18n.locale==='en')
    {
      document.title="Zhejiang Pan-am Co.,ltd"
    }else{
      document.title="帅孚"
    }
    this.wow=new WOW();
    Scrollbar.initAll();
    this.init()
    this.$router.beforeEach((to, from, next) => {
      Scrollbar.destroyAll()
      next()
    })
  },
  methods:{
    init(){
      this.$nextTick(()=>{
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        this.wow.init()
        this.noShow={display:'block'}
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,0)
        scrollbar.addListener((status) => {
          window.pageYOffset=status.offset.y
          if(window.pageYOffset>0){
            this.noShow={display:'none'}
          }else{

          }
          this.wow.scrollHandler()
        })
      })
    }
  }

}
</script>

<style>
  .donghua{
    height:100vh;
    width:100%;
    position: absolute;
    top:0;
    left:0;
    z-index: 999;
    color:white;
    background-color: black;
    animation-duration: 3s;
  }
  body{
    margin: 0;
    padding: 0;
  }
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height:100vh;
  font-family: light;
}
  #scroller-wrapper{
    position: relative;
    height: 100vh;
    overflow: hidden;
    /* z-index: 101; */
  }
  .scrollbar-thumb{
    width:2px !important;
    background-color: #C9382C !important;
  }
  .scrollbar-track-y{
    width:3px !important;
  }
  .animated{
    animation-duration: 2.5s;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue